// extracted by mini-css-extract-plugin
export default {"imageWrapper":"PhotoContainer_imageWrapper__sll+n","imageContainer":"PhotoContainer_imageContainer__YwKpf","image":"PhotoContainer_image__r3hDu"};